import { StateCreator } from 'zustand';

import { Store } from 'store';
import { APIUserObj } from 'api/types';
import { formatPhone } from 'lib/utils';
import { AuthBottomSheetState } from './ui';

export interface UserSlice {
  user: APIUserObj | null;
  authToken: string | null;

  lastSelectedFacilityList?: { notificationId?: number; favouritesListId?: number };
  setLastSelectedFacilityList: (
    lastSelectedFacilityList: { notificationId?: number; favouritesListId?: number } | undefined,
  ) => void;

  authCode: string;
  setAuthCode: (code: string) => void;

  authPhone: string;
  setAuthPhone: (phone: string) => void;

  personalDataConsent: boolean;
  privacyPolicyConsent: boolean;
  marketingConsent: boolean;

  setPersonalDataConsent: (value: boolean) => void;
  setPrivacyPolicyConsent: (value: boolean) => void;
  setMarketingConsent: (value: boolean) => void;

  setUser: (user: APIUserObj, token?: string) => void;
  clearUser: () => void;
}

const createUserSlice: StateCreator<Store, [['zustand/immer', never]], [], UserSlice> = (set) => ({
  user: null,
  authToken: null,

  authCode: '',
  setAuthCode: (authCode) => set({ authCode }),

  authPhone: '',
  setAuthPhone: (authPhone) => set({ authPhone }),

  personalDataConsent: false,
  privacyPolicyConsent: false,
  marketingConsent: false,

  setPersonalDataConsent: (personalDataConsent: boolean) => set({personalDataConsent}),
  setPrivacyPolicyConsent: (privacyPolicyConsent: boolean) => set({privacyPolicyConsent}),
  setMarketingConsent: (marketingConsent: boolean) => set({marketingConsent}),

  lastSelectedFacilityList: undefined,
  setLastSelectedFacilityList: (lastSelectedFacilityList) => set({ lastSelectedFacilityList }),

  setUser: (user, token) => {
    set((store) => {
      store.user = { ...user, phone: formatPhone(user.phone) };
      store.authPhone = '';

      if (token) store.authToken = token;

      // Заставляем пользователя вводить имя
      if (!user.firstName && !store.isAuthBottomSheetOpen) {
        store.isAuthBottomSheetOpen = true;
        store.authBottomSheetState = AuthBottomSheetState.inputName;
      }
    });
  },
  clearUser: () => {
    set({ authToken: null, user: null });
  },
});

export default createUserSlice;
